(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(null);
  else if (root.YellowStoreLocator2026) root.YellowStoreLocator2026.scan();
  else root.YellowStoreLocator2026 = factory(root);
})(typeof window === 'undefined' ? null : window, function (win) {
  'use strict';
  const THEME_ID = '179835699393';
  const APP_THEME_IDS = ['179639091393', '179881279681', '179882950849'];
  const activeLocations = locations => locations.filter(location => location && !location.deleted_at);
  const slugify = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const storeSlug = location => location.store_code && location.city ? slugify(location.store_code + '-yellow-' + location.city) : 'store-' + slugify(location.id);
  const localized = (location, field, french) => String((french && location[field + '_fr']) || location[field] || '').trim();
  function resolveStore(locations, requested) {
    const slug = slugify(requested);
    const exact = locations.find(entry => storeSlug(entry) === slug);
    if (exact) return exact;
    const normalize = value => value.replace(/^0+(\d+-yellow-)/, '$1');
    const matches = locations.filter(entry => normalize(storeSlug(entry)) === normalize(slug));
    return matches.length === 1 ? matches[0] : null;
  }
  const displayName = (location, french) => localized(location, 'name', french)
    .replace(/^\d+\s*-\s*/, '').replace(/^Yellow(?:\s+Express|\s+Sat)?\s*-?\s*/i, '')
    .replace(/^Mtl\s*Nd\s*-\s*/i, 'Montréal · ').replace(/^Mtl\s*-\s*/i, 'Montréal · ').replace(/^Qc\s*-\s*/i, 'Québec · ') || localized(location, 'city', french);
  function seoValues(location, french) {
    const name = displayName(location, french), suffix = french ? '_fr' : '';
    const value = field => typeof location[field + suffix] === 'string' ? location[field + suffix].trim() : '';
    return {
      title: value('seo_title') || name + ' | Yellow Shoes',
      description: value('seo_description') || (french
        ? 'Visitez Yellow à ' + name + '. Consultez l’adresse, le téléphone, les heures d’ouverture et l’itinéraire du magasin.'
        : 'Visit Yellow Shoes in ' + name + '. Find the store address, phone number, opening hours and directions.')
    };
  }
  const address = (location, french) => [localized(location, 'line1', french), localized(location, 'line2', french), localized(location, 'city', french), localized(location, 'state', french), location.zip, localized(location, 'country', french)].filter(Boolean).join(', ');
  function hours(location, french) {
    const days = { Monday: 'Lundi', Tuesday: 'Mardi', Wednesday: 'Mercredi', Thursday: 'Jeudi', Friday: 'Vendredi', Saturday: 'Samedi', Sunday: 'Dimanche' };
    let value = localized(location, 'hours', french);
    Object.entries(days).forEach(([en, fr]) => {
      value = value.replace(new RegExp(en + '\\s*/\\s*' + fr, 'gi'), french ? fr : en);
      if (french) value = value.replace(new RegExp('\\b' + en + '\\b', 'g'), fr);
    });
    return value;
  }
  const coordinates = location => {
    const lat = Number.parseFloat(location.lat), lng = Number.parseFloat(location.lng);
    return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat, lng } : null;
  };
  function distance(a, b) {
    const radians = n => n * Math.PI / 180;
    const dLat = radians(b.lat - a.lat), dLng = radians(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(radians(a.lat)) * Math.cos(radians(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(Math.min(1, h)), Math.sqrt(Math.max(0, 1 - h)));
  }
  function results(locations, origin, radius, city) {
    return locations.map(location => ({ location, distance: origin && coordinates(location) ? distance(origin, coordinates(location)) : null }))
      .filter(entry => (!city || city === 'all' || slugify(entry.location.city) === slugify(city)) && (!origin || (entry.distance !== null && entry.distance <= radius)))
      .sort((a, b) => origin ? a.distance - b.distance || Number(a.location.store_code) - Number(b.location.store_code) : Number(a.location.store_code) - Number(b.location.store_code));
  }
  const safeImageUrl = value => {
    try { const url = new URL(value); return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : null; } catch (_) { return null; }
  };
  function directions(location, french) {
    const point = coordinates(location);
    const destination = point ? point.lat + ',' + point.lng : address(location, french);
    return destination ? 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(destination) : null;
  }
  const validOption = (value, options, fallback) => options.includes(Number(value)) ? Number(value) : fallback;
  const SCHEMA_DAYS = { monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday', thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday' };
  const SCHEMA_DAYS_FR = { lundi: 'Monday', mardi: 'Tuesday', mercredi: 'Wednesday', jeudi: 'Thursday', vendredi: 'Friday', samedi: 'Saturday', dimanche: 'Sunday' };
  // The stored blob reads "Monday/Lundi: 10:00-18:00" per line, with two quirks
  // consistent across every record: the Sunday line carries no colon after the
  // day name, and a closed day reads FERMÉ. Google expects a closed day as
  // opens == closes == "00:00", not as an absent entry.
  function openingHours(location, french) {
    const pad = value => (Number(value) < 10 ? '0' : '') + Number(value);
    const dayOf = line => {
      const key = Object.keys(SCHEMA_DAYS).find(day => new RegExp('^\\s*' + day, 'i').test(line));
      if (key) return SCHEMA_DAYS[key];
      const fr = Object.keys(SCHEMA_DAYS_FR).find(day => new RegExp('^\\s*' + day, 'i').test(line));
      return fr ? SCHEMA_DAYS_FR[fr] : null;
    };
    return localized(location, 'hours', french).split(/\r?\n/).reduce((spec, line) => {
      const day = dayOf(line);
      if (!day) return spec;
      const range = line.match(/(\d{1,2})\s*[:h]\s*(\d{2})\s*[-–—]\s*(\d{1,2})\s*[:h]\s*(\d{2})/);
      if (range) spec.push({ '@type': 'OpeningHoursSpecification', dayOfWeek: 'https://schema.org/' + day, opens: pad(range[1]) + ':' + range[2], closes: pad(range[3]) + ':' + range[4] });
      else if (/ferm|closed/i.test(line)) spec.push({ '@type': 'OpeningHoursSpecification', dayOfWeek: 'https://schema.org/' + day, opens: '00:00', closes: '00:00' });
      return spec;
    }, []);
  }
  // One ShoeStore node, shared by the detail page and the directory ItemList so
  // both describe the same entity identically.
  function schemaNode(location, url, french) {
    const point = coordinates(location), image = safeImageUrl(location.image_url);
    const node = { '@type': 'ShoeStore', '@id': url + '#store', name: 'Yellow Shoes — ' + displayName(location, french), url,
      branchCode: String(location.store_code || ''),
      parentOrganization: { '@type': 'Organization', name: 'Yellow Shoes', url: new URL(url).origin + '/' },
      currenciesAccepted: 'CAD', priceRange: '$$',
      address: { '@type': 'PostalAddress', streetAddress: [localized(location, 'line1', french), localized(location, 'line2', french)].filter(Boolean).join(', '), addressLocality: localized(location, 'city', french), addressRegion: localized(location, 'state', french), postalCode: location.zip || '', addressCountry: location.country || 'CA' } };
    if (point) node.geo = { '@type': 'GeoCoordinates', latitude: point.lat, longitude: point.lng };
    if (location.phone) node.telephone = location.phone;
    if (image) node.image = image;
    if (location.google_place_id) node.hasMap = 'https://www.google.com/maps/place/?q=place_id:' + location.google_place_id;
    const opening = openingHours(location, french);
    if (opening.length) node.openingHoursSpecification = opening;
    return node;
  }
  const api = { slugify, storeSlug, resolveStore, displayName, seoValues, localized, address, hours, openingHours, schemaNode, coordinates, distance, results, safeImageUrl, directions, validOption };
  if (!win) return api;

  const doc = win.document;
  const loads = new Map();
  const text = {
    en: { loading: 'Loading stores…', loadError: 'The store directory is temporarily unavailable. Please try again.', searching: 'Searching for stores…', locating: 'Finding stores near you…', geoDenied: 'Location access was denied. Search by postal code or city instead.', geoError: 'Your location could not be found. Search by postal code or city instead.', searchError: 'Search is temporarily unavailable. Your previous results are still shown. Please try again.', noMatch: 'No location matched your search. Try another postal code or city.', count: (n, shown) => n + (n === 1 ? ' store found' : ' stores found') + ' · Showing ' + shown + ' of ' + n, phone: 'Store number:', directions: 'Get directions', details: 'View store details', away: 'km away', notFound: 'Store not found', description: name => 'Visit Yellow Shoes in ' + name + '. Find the store address, phone number, opening hours and directions.' },
    fr: { loading: 'Chargement des magasins…', loadError: 'Le répertoire des magasins est temporairement indisponible. Veuillez réessayer.', searching: 'Recherche de magasins…', locating: 'Recherche de magasins près de vous…', geoDenied: 'L’accès à votre position a été refusé. Recherchez plutôt par code postal ou par ville.', geoError: 'Votre position est introuvable. Recherchez plutôt par code postal ou par ville.', searchError: 'La recherche est temporairement indisponible. Les résultats précédents restent affichés. Veuillez réessayer.', noMatch: 'Aucun lieu ne correspond à votre recherche. Essayez un autre code postal ou une autre ville.', count: (n, shown) => n + (n === 1 ? ' magasin trouvé' : ' magasins trouvés') + ' · ' + shown + ' sur ' + n + ' affichés', phone: 'Téléphone :', directions: 'Itinéraire', details: 'Voir les détails du magasin', away: 'km de distance', notFound: 'Magasin introuvable', description: name => 'Visitez Yellow à ' + name + '. Consultez l’adresse, le téléphone, les heures d’ouverture et l’itinéraire du magasin.' }
  };
  function element(tag, className, value) {
    const node = doc.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined && value !== null) node.textContent = value;
    return node;
  }
  function load(section) {
    if (section.dataset.sourceType === 'app-settings' || APP_THEME_IDS.includes(String(win.Shopify?.theme?.id))) {
      section.dataset.sourceType = 'app-settings';
      return loadAppSettings(section.dataset.settingsUrl);
    }
    const url = section.dataset.source;
    if (!loads.has(url)) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      const promise = fetch(url, { signal: controller.signal, credentials: 'omit' }).then(response => {
        if (!response.ok) throw new Error('Directory unavailable');
        return response.json();
      }).then(data => {
        if (data.schema_version !== 1 || data.theme_id !== THEME_ID || !Array.isArray(data.locations)) throw new Error('Unexpected directory');
        return activeLocations(data.locations);
      }).catch(error => { loads.delete(url); throw error; }).finally(() => clearTimeout(timer));
      loads.set(url, promise);
    }
    return loads.get(url);
  }
  function loadAppSettings(url) {
    if (Array.isArray(win.app_settings?.locations)) return Promise.resolve(activeLocations(win.app_settings.locations));
    const key = 'app-settings:' + url;
    if (!loads.has(key)) {
      const promise = new Promise((resolve, reject) => {
        // The layout normally loads this before our deferred script. Retry its exact
        // generated asset URL if that request failed; never fall back to stale draft data.
        const script = doc.createElement('script');
        let timer;
        function finish(error) {
          clearTimeout(timer); script.remove();
          if (error) reject(error);
          else if (Array.isArray(win.app_settings?.locations)) resolve(activeLocations(win.app_settings.locations));
          else reject(new Error('Unexpected app directory'));
        }
        try {
          const source = new URL(url, win.location.origin);
          if (!url || !['http:', 'https:'].includes(source.protocol)) throw new Error('Missing settings source');
          script.src = source.href;
          script.onload = () => finish(); script.onerror = () => finish(new Error('App directory unavailable'));
          timer = setTimeout(() => finish(new Error('App directory timed out')), 15000);
          doc.head.append(script);
        } catch (error) { finish(error); }
      }).catch(error => { loads.delete(key); throw error; });
      loads.set(key, promise);
    }
    return loads.get(key);
  }
  function internalUrl(path, location) {
    const url = new URL(path, win.location.origin);
    if (location) url.searchParams.set('store', storeSlug(location));
    const preview = new URLSearchParams(win.location.search).get('preview_theme_id') || (win.Shopify?.theme?.role === 'unpublished' && [THEME_ID, ...APP_THEME_IDS].includes(String(win.Shopify.theme.id)) ? String(win.Shopify.theme.id) : null);
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }
  function placeholder(location, french) {
    const box = element('div', 'sl-placeholder');
    box.append(element('strong', '', 'Yellow'), element('span', '', displayName(location, french)));
    return box;
  }
  function media(location, french, eager) {
    const url = safeImageUrl(location.image_url);
    if (!url) return placeholder(location, french);
    const image = element('img', 'sl-image');
    image.src = url;
    const resized = width => { const u = new URL(url); u.searchParams.set('width', width); return u.href + ' ' + width + 'w'; };
    image.srcset = [384, 768, 1152, 1536].map(resized).join(', ');
    image.sizes = eager ? '(max-width:650px) calc(100vw - 40px), (max-width:1200px) 55vw, 720px' : '(max-width:650px) calc(100vw - 40px), (max-width:1200px) calc(50vw - 42px), 542px';
    image.width = 1536; image.height = 864;
    image.alt = displayName(location, french) + ' — ' + localized(location, 'line1', french);
    image.loading = eager ? 'eager' : 'lazy';
    image.decoding = 'async';
    image.addEventListener('error', () => image.replaceWith(placeholder(location, french)), { once: true });
    return image;
  }
  function card(entry, section, french, labels) {
    const location = entry.location;
    const article = element('article', 'sl-card');
    const link = element('a', 'sl-card-media');
    link.href = internalUrl(section.dataset.storeUrl, location);
    link.setAttribute('aria-label', labels.details + ': ' + displayName(location, french));
    link.append(media(location, french, false));
    const heading = element('h2', 'sl-card-title');
    const title = element('a', '', displayName(location, french)); title.href = link.href; heading.append(title);
    const contact = element('div', 'sl-card-contact');
    contact.append(element('p', '', address(location, french)));
    if (location.phone) {
      const phone = element('p'); phone.append(element('span', 'sl-phone-label', labels.phone));
      const phoneLink = element('a', 'sl-card-phone', location.phone); phoneLink.href = 'tel:' + String(location.phone).replace(/[^+\d]/g, ''); phone.append(phoneLink); contact.append(phone);
    }
    article.append(link, heading, contact);
    const route = directions(location, french);
    if (route) { const directionLink = element('a', 'sl-button sl-card-directions', labels.directions); directionLink.href = route; directionLink.target = '_blank'; directionLink.rel = 'noopener noreferrer'; article.append(directionLink); }
    if (entry.distance !== null) article.append(element('p', 'sl-distance', new Intl.NumberFormat(french ? 'fr-CA' : 'en-CA', { maximumFractionDigits: 1 }).format(entry.distance) + ' ' + labels.away));
    return article;
  }
  function geocode(query) {
    return new Promise((resolve, reject) => {
      const started = Date.now();
      const timer = setInterval(() => {
        if (win.google && win.google.maps && win.google.maps.Geocoder) {
          clearInterval(timer);
          let finished = false;
          const timeout = setTimeout(() => { finished = true; reject(new Error('Geocoder timeout')); }, 12000);
          new win.google.maps.Geocoder().geocode({ address: query, componentRestrictions: { country: 'CA' } }, (matches, status) => {
            if (finished) return;
            clearTimeout(timeout); finished = true;
            if (status === 'OK' && matches && matches[0]) resolve({ lat: matches[0].geometry.location.lat(), lng: matches[0].geometry.location.lng() });
            else { const error = new Error('Geocoding failed'); error.noMatch = status === 'ZERO_RESULTS'; reject(error); }
          });
        } else if (Date.now() - started > 12000) { clearInterval(timer); reject(new Error('Geocoder unavailable')); }
      }, 100);
    });
  }
  function createStoreMap(section, french, labels) {
    const canvas = section.querySelector('[data-map]'), status = section.querySelector('[data-map-status]');
    if (!canvas || !status) return { update() {}, unavailable() {} };
    const mapText = french
      ? { empty: 'Aucun magasin correspondant ne peut \u00eatre affich\u00e9 sur la carte.', error: 'La carte est temporairement indisponible. Les magasins restent accessibles ci-dessous.' }
      : { empty: 'No matching stores can be shown on the map.', error: 'The store map is temporarily unavailable. Store details remain available below.' };
    const markerSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36"><path fill="#3d3d3d" d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 22 14 22s14-11.5 14-22C28 6.27 21.73 0 14 0Z"/><circle cx="14" cy="14" r="5" fill="#fff"/></svg>';
    const markers = new Map();
    let matches = [], map = null, popup = null, lastKey = null, dataReady = false, sdkReady = false, failed = false;
    function message(value) { status.textContent = value; status.hidden = false; }
    function storePopup(location) {
      const content = element('div', 'sl-map-popup');
      if (safeImageUrl(location.image_url)) content.append(media(location, french, false));
      content.append(element('h3', '', displayName(location, french)));
      const storeAddress = address(location, french);
      if (storeAddress) content.append(element('p', '', storeAddress));
      if (location.phone) {
        const row = element('p'), phone = element('a', '', location.phone);
        phone.href = 'tel:' + String(location.phone).replace(/[^+\d]/g, ''); row.append(phone); content.append(row);
      }
      const storeHours = hours(location, french);
      if (storeHours) content.append(element('p', 'sl-map-popup-hours', storeHours));
      const links = element('div', 'sl-map-popup-links'), details = element('a', '', labels.details), route = element('a', '', labels.directions);
      details.href = internalUrl(section.dataset.storeUrl, location);
      route.href = directions(location, french); route.target = '_blank'; route.rel = 'noopener noreferrer';
      links.append(details, route); content.append(links); return content;
    }
    function refresh() {
      if (!dataReady || !sdkReady || failed || !section.isConnected) return;
      try {
        const entries = matches.filter(entry => !entry.location.deleted_at && coordinates(entry.location));
        const key = JSON.stringify(entries.map(entry => [entry.location.id, coordinates(entry.location)]));
        if (key === lastKey) return;
        if (popup) popup.close();
        if (!entries.length) {
          markers.forEach(marker => marker.setMap(null)); lastKey = key; message(mapText.empty); return;
        }
        const maps = win.google.maps;
        if (!map) {
          map = new maps.Map(canvas, { center: { lat: 45.5019, lng: -73.5674 }, zoom: 8,
            mapTypeControl: true, mapTypeControlOptions: { style: maps.MapTypeControlStyle.HORIZONTAL_BAR, position: maps.ControlPosition.TOP_LEFT },
            streetViewControl: true, fullscreenControl: true, gestureHandling: 'cooperative' });
          popup = new maps.InfoWindow({ maxWidth: 320 });
        }
        const visible = new Set(entries.map(entry => String(entry.location.id)));
        markers.forEach((marker, id) => { if (!visible.has(id)) marker.setMap(null); });
        entries.forEach(({location}) => {
          const id = String(location.id), position = coordinates(location);
          if (!markers.has(id)) {
            const marker = new maps.Marker({ position, map, title: displayName(location, french), optimized: false,
              icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(markerSvg), scaledSize: new maps.Size(28, 36), anchor: new maps.Point(14, 36) } });
            marker.addListener('click', () => {
              popup.setContent(storePopup(location)); popup.setOptions({ ariaLabel: displayName(location, french) }); popup.open({map, anchor: marker, shouldFocus: true});
            });
            markers.set(id, marker);
          } else { markers.get(id).setPosition(position); markers.get(id).setMap(map); }
        });
        if (entries.length === 1) { map.setCenter(coordinates(entries[0].location)); map.setZoom(13); }
        else { const bounds = new maps.LatLngBounds(); entries.forEach(entry => bounds.extend(coordinates(entry.location))); map.fitBounds(bounds, 35); }
        lastKey = key; status.hidden = true;
      } catch (_) { failed = true; message(mapText.error); }
    }
    const started = Date.now();
    const timer = setInterval(() => {
      if (!section.isConnected) { clearInterval(timer); return; }
      if (typeof win.google?.maps?.Map === 'function' && typeof win.google.maps.Marker === 'function' && typeof win.google.maps.InfoWindow === 'function') {
        clearInterval(timer); sdkReady = true; refresh();
      } else if (Date.now() - started >= 15000) { clearInterval(timer); failed = true; message(mapText.error); }
    }, 100);
    return {
      update(entries) { matches = entries; dataReady = true; refresh(); },
      unavailable() { dataReady = false; message(mapText.error); }
    };
  }
  function initList(section, french, labels) {
    const find = selector => section.querySelector(selector);
    const form = find('[data-search]'), grid = find('[data-grid]'), status = find('[data-status]');
    const more = find('[data-more]'), retry = find('[data-retry]'), empty = find('[data-empty]'), nearby = find('[data-nearby]');
    const storeMap = createStoreMap(section, french, labels);
    const params = new URLSearchParams(win.location.search);
    const state = { locations: [], origin: null, city: params.get('city') || '', query: params.get('q') || '', radius: validOption(params.get('radius'), [10,25,50,100], 25), limit: validOption(params.get('limit'), [10,20,40,50], 10), page: Math.max(1, Math.min(100, Number.parseInt(params.get('page'), 10) || 1)), busy: false, ready: false, sequence: 0, matches: [] };
    form.elements.q.value = state.query; form.elements.radius.value = state.radius; form.elements.limit.value = state.limit;
    function message(value, error) { status.textContent = value; status.dataset.error = error ? 'true' : 'false'; }
    function busy(value) { state.busy = value; form.querySelectorAll('button,input,select').forEach(control => { control.disabled = value || !state.ready; }); nearby.disabled = value || !state.ready; more.disabled = value; grid.setAttribute('aria-busy', String(value)); }
    function updateUrl() {
      const url = new URL(win.location.href);
      ['q','city','radius','limit','page'].forEach(key => url.searchParams.delete(key));
      if (state.query) url.searchParams.set('q', state.query);
      if (state.city && state.city !== 'all') url.searchParams.set('city', state.city);
      if (state.radius !== 25) url.searchParams.set('radius', state.radius);
      if (state.limit !== 10) url.searchParams.set('limit', state.limit);
      if (state.page > 1) url.searchParams.set('page', state.page);
      win.history.replaceState({}, '', url);
    }
    function render(append) {
      state.matches = results(state.locations, state.origin, state.radius, state.city);
      storeMap.update(state.matches);
      state.page = Math.min(state.page, Math.max(1, Math.ceil(state.matches.length / state.limit)));
      const visible = state.matches.slice(0, state.limit * state.page);
      const start = append ? grid.children.length : 0;
      if (!append) grid.replaceChildren();
      const fragment = doc.createDocumentFragment(); visible.slice(start).forEach(entry => fragment.append(card(entry, section, french, labels))); grid.append(fragment);
      empty.hidden = state.matches.length > 0; more.hidden = visible.length >= state.matches.length;
      message(labels.count(state.matches.length, visible.length)); updateUrl();
    }
    async function search(restorePage) {
      if (state.busy || !state.ready) return;
      const query = form.elements.q.value.trim();
      state.radius = Number(form.elements.radius.value); state.limit = Number(form.elements.limit.value);
      if (!restorePage) state.page = 1;
      const sequence = ++state.sequence;
      if (!query) { state.origin = null; state.city = ''; state.query = ''; render(); return; }
      busy(true); message(labels.searching);
      try {
        const point = await geocode(query);
        if (sequence !== state.sequence) return;
        state.origin = point; state.city = ''; state.query = query; render();
      } catch (error) { message(error.noMatch ? labels.noMatch : labels.searchError, true); }
      finally { if (sequence === state.sequence) busy(false); }
    }
    form.addEventListener('submit', event => { event.preventDefault(); search(false); });
    form.elements.radius.addEventListener('change', () => { state.radius = Number(form.elements.radius.value); state.page = 1; render(); });
    form.elements.limit.addEventListener('change', () => { state.limit = Number(form.elements.limit.value); state.page = 1; render(); });
    more.addEventListener('click', () => { state.page++; render(true); });
    find('[data-reset]').addEventListener('click', () => { form.elements.q.value = ''; state.city = ''; state.origin = null; state.query = ''; state.page = 1; render(); form.elements.q.focus(); });
    nearby.addEventListener('click', () => {
      if (state.busy || !state.ready) return;
      if (!win.navigator.geolocation) { message(labels.geoError, true); form.elements.q.focus(); return; }
      busy(true); message(labels.locating); const sequence = ++state.sequence;
      win.navigator.geolocation.getCurrentPosition(position => {
        if (sequence !== state.sequence) return;
        state.origin = { lat: position.coords.latitude, lng: position.coords.longitude }; state.query = ''; state.city = ''; state.page = 1; form.elements.q.value = ''; render(); busy(false);
      }, error => { if (sequence !== state.sequence) return; busy(false); message(error.code === 1 ? labels.geoDenied : labels.geoError, true); form.elements.q.focus(); }, { timeout: 12000, maximumAge: 60000, enableHighAccuracy: false });
    });
    // Summary-page ItemList: every store as a full ShoeStore node, since the
    // directory is currently the only place a non-rendering crawler sees them.
    function listSchema(locations) {
      if (!locations.length) return null;
      return { '@context': 'https://schema.org', '@type': 'ItemList',
        '@id': new URL(section.dataset.listUrl, win.location.origin).href + '#stores',
        name: 'Yellow store directory', numberOfItems: locations.length,
        itemListOrder: 'https://schema.org/ItemListUnordered',
        itemListElement: locations.map((location, index) => ({ '@type': 'ListItem', position: index + 1, item: schemaNode(location, storeCanonical(section, location), french) })) };
    }
    async function reload() {
      retry.hidden = true; busy(true); message(labels.loading);
      try { state.locations = await load(section); state.ready = true; emitSchema('store-list-structured-data', listSchema(state.locations)); render(); busy(false); if (state.query) await search(true); }
      catch (_) { message(labels.loadError, true); retry.hidden = false; busy(false); storeMap.unavailable(); }
    }
    retry.addEventListener('click', reload); reload();
  }
  function emitSchema(id, payload) {
    const previous = doc.getElementById(id);
    if (previous) previous.remove();
    if (!payload) return;
    const script = doc.createElement('script');
    script.id = id; script.type = 'application/ld+json';
    script.textContent = JSON.stringify(payload);
    doc.head.append(script);
  }
  // Clean canonical for a store: no preview or search params, so the detail
  // page and the directory ItemList agree on one @id per store.
  function storeCanonical(section, location) {
    const url = new URL(section.dataset.storeUrl, win.location.origin);
    url.search = ''; url.hash = '';
    if (location) url.searchParams.set('store', storeSlug(location));
    return url.href;
  }
  // Mirrors the rendered breadcrumb, so its labels and locale-prefixed hrefs
  // stay correct without the section having to repeat them as data attributes.
  function breadcrumb(section, name) {
    const links = Array.from(section.querySelectorAll('.sl-breadcrumbs a'));
    if (!links.length) return null;
    const items = links.map((link, index) => ({ '@type': 'ListItem', position: index + 1, name: link.textContent.trim(), item: new URL(link.getAttribute('href'), win.location.origin).href }));
    items.push({ '@type': 'ListItem', position: items.length + 1, name });
    return { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: items };
  }
  function setMeta(selector, attribute, key, value) {
    let node = doc.querySelector(selector);
    if (!node) { node = doc.createElement('meta'); node.setAttribute(attribute, key); doc.head.append(node); }
    node.content = value;
  }
  function seo(section, location, french, labels) {
    const canonical = new URL(storeCanonical(section, location));
    let link = doc.querySelector('link[rel=canonical]'); if (!link) { link = doc.createElement('link'); link.rel = 'canonical'; doc.head.append(link); } link.href = canonical.href;
    const robots = doc.getElementById('store-detail-robots'); if (robots) robots.remove();
    if (!location) {
      emitSchema('store-detail-structured-data', null);
      emitSchema('store-detail-breadcrumb', null);
      const noindex = doc.createElement('meta'); noindex.id = 'store-detail-robots'; noindex.name = 'robots'; noindex.content = 'noindex,follow'; doc.head.append(noindex); doc.title = labels.notFound + ' | Yellow Shoes'; return;
    }
    const name = displayName(location, french), { title, description } = seoValues(location, french);
    doc.title = title;
    setMeta('meta[name=description]', 'name', 'description', description);
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', canonical.href);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
    const image = safeImageUrl(location.image_url);
    if (image) setMeta('meta[property="og:image"]', 'property', 'og:image', image);
    emitSchema('store-detail-structured-data', Object.assign({ '@context': 'https://schema.org' }, schemaNode(location, canonical.href, french)));
    emitSchema('store-detail-breadcrumb', breadcrumb(section, name));
  }
  function initDetail(section, french, labels) {
    const find = selector => section.querySelector(selector);
    const status = find('[data-status]'), retry = find('[data-retry]');
    section.querySelectorAll('[data-back-link]').forEach(link => { link.href = internalUrl(section.dataset.listUrl); });
    async function reload() {
      retry.hidden = true; status.hidden = false; status.textContent = labels.loading;
      try {
        const locations = await load(section);
        const requested = new URLSearchParams(win.location.search).get('store');
        const location = requested ? resolveStore(locations, requested) : null;
        status.hidden = true;
        if (!location) { find('[data-not-found]').hidden = false; find('[data-title]').textContent = labels.notFound; seo(section, null, french, labels); return; }
        const name = displayName(location, french), street = localized(location, 'line1', french), fullAddress = address(location, french);
        if (requested && slugify(requested) !== storeSlug(location)) {
          const url = new URL(win.location.href); url.searchParams.set('store', storeSlug(location)); win.history.replaceState({}, '', url);
        }
        find('[data-title]').textContent = name; find('[data-breadcrumb]').textContent = name;
        find('[data-subtitle]').textContent = [street, localized(location, 'city', french)].filter(Boolean).join(', ');
        find('[data-media]').replaceChildren(media(location, french, true)); find('[data-address]').textContent = fullAddress;
        find('[data-address-row]').hidden = !fullAddress;
        const route = directions(location, french); find('[data-directions]').hidden = !route; if (route) find('[data-directions]').href = route;
        find('[data-phone-row]').hidden = !location.phone; find('[data-phone]').textContent = location.phone || ''; find('[data-phone]').href = 'tel:' + String(location.phone || '').replace(/[^+\d]/g, '');
        const storeHours = hours(location, french); find('[data-hours-row]').hidden = !storeHours; find('[data-hours]').textContent = storeHours;
        find('[data-detail]').hidden = false; find('[data-services]').hidden = false; seo(section, location, french, labels);
      } catch (_) { status.textContent = labels.loadError; status.dataset.error = 'true'; retry.hidden = false; }
    }
    retry.addEventListener('click', reload); reload();
  }
  function scan() {
    doc.querySelectorAll('.sl2026').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const french = (section.dataset.language || doc.documentElement.lang).toLowerCase().startsWith('fr');
      (section.dataset.mode === 'detail' ? initDetail : initList)(section, french, french ? text.fr : text.en);
    });
  }
  api.scan = scan;
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan); else scan();
  doc.addEventListener('shopify:section:load', scan);
  return api;
});
